export default __webpack_public_path__ + "static/media/background.ec074d0b.jpg";